exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-row[data-v-07a3f9a1]{display:flex;justify-content:space-between;margin-bottom:3px}.info-row.padded[data-v-07a3f9a1]{margin-left:15px}.info-row:not(.padded) span[data-v-07a3f9a1]:first-child{font-weight:500}.info-row span[data-v-07a3f9a1]:last-child{text-align:end}", ""]);

// exports
